<template>
  <wo-card :title="title">
    <slot name="actions" slot="actions" />
    <po-table v-if="hasUsers">
      <po-table-header :columns="tableColumns" slot="header" />
      <template slot="body">
        <tr v-for="user in users.items" :key="user.id">
          <td><po-route-link :value="getRoute(user)" :label="user.display_name" /></td>
          <td>{{ user.email }}</td>
          <td><user-status-badge :value="user" /></td>
          <td>{{ user.created_on | date }}</td>
        </tr>
      </template>
    </po-table>
    <po-empty-state v-else />
    <po-paging v-model="currentPage" :data="users" />
  </wo-card>
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'
import filtered from '@/mixins/filtered'

import { userRepository } from '@/repository/identity'

import { ADMIN_USER } from '@/routes/admin'

import UserStatusBadge from '@/components/identity/UserStatusBadge'

export default {
  components: { UserStatusBadge },
  mixins: [filtered],
  props: {
    filter: Object,
    titleKey: { type: String, default: 'admin.users.matching' }
  },
  computed: mapState({
    users: state => state.identity.userList,
    hasUsers () {
      return this.users && !_.isEmpty(this.users.items)
    },
    title () {
      return this.$t(this.titleKey)
    },
    tableColumns () {
      return [
        { labelKey: 'user.displayName', prop: 'display_name' },
        { labelKey: 'user.email', prop: 'email' },
        { labelKey: 'general.status', prop: 'status' },
        { labelKey: 'user.createdOn', prop: 'created_on' }
      ]
    }
  }),
  methods: {
    applyFilter (filter, pristine) {
      return this.$store.dispatch(userRepository.findAll, { filter: filter, replace: !pristine })
    },
    getRoute (user) {
      return {
        name: ADMIN_USER,
        params: { userId: user.id }
      }
    }
  }
}
</script>
